export const environment = {
  production: false,
  pr1ApiUrl: 'https://pr1stdqa.przone.net/pr1core/Private',
  appKey: 'commerce engine',
  environment: 'qa',
  appMode: 'standalone',
  commentApiUrl: 'https://pr1stdqa.przone.net/pr1commentapi/Private',
  shopifyAuth: {
    apiKey: '',
    host: '',
  },
  applicationInsights: {
    enabled: false,
    connectionString: 'InstrumentationKey=eb3443ff-748f-4380-8b70-f7eaafc5ea99;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=d0d0da5e-a1f3-46d8-bff3-8a24bae92272', // qa environment
    enableCorsCorrelation: false,
    enableRequestHeaderTracking: false,
    enableResponseHeaderTracking: false,
  },
  knockApp: {
    FEED_KEY: 'b8a11870-97b0-47a5-a95c-9dee1131200e',
    CLIENT_KEY: 'pk_MJOElQTiKC46LYx1htZMBF_iMpN5c6Qn4ZjbzZWA3Iw',
  },
  auth: {
    domain: 'pr1-test.us.auth0.com',
    clientId: '3piKdUctouNlsqnukXcj8L4p2XptPPAT',
    audience: 'https://pr1-std-private-api.przone.net',
    organization: 'org_GOY5hYYiRctXRQC6',
    redirectUri: window.location.origin + '/pr1core/',
  },
  keycloak: {
    url: 'https://auth.europe-west1.storyteq.work/',
    realm: 'Commerce-Engine-QA',
    clientId: 'pr1stdqa.przone.net',
    redirectUri: window.location.origin + '/pr1core/',
  },
  httpInterceptor: {
    allowedList: [`https://pr1stdqa.przone.net/pr1core/Private/*`, `https://pr1stdqa.przone.net/pr1commentapi/Private/*`],
  },
  blobStorage: {
    kroger: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
      helpDocPath: '/docs/kroger/KRG_Commerce_Engine_User_Guide_021826.pdf'
    },
    riteaid: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    standard: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    walgreens: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    demo: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    qaautomation: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    unfi: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    arg: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    tractorsupply: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
    schnucks: {
      assetsUrl:
        'https://pr1stdqastandardblob.blob.core.windows.net/public/assets',
    },
  },
  useAuth0: false
};
